import axios from 'axios';
import { ApiStatus, getResponseData, isResponseStatusSuccess } from './api.utils';
import { managerAxios } from './baseApis';
export const sendDecision = async (decision) => {
    const endpoint = `HolidayBooking/${decision.approveOrReject}`;
    const response = await axios.post(endpoint, { bookingId: decision.bookingId, reason: decision.rejectionReason }, { skipAuth: true });
    if (!isResponseStatusSuccess(response?.status)) {
        return {
            status: ApiStatus.Failed,
            errorText: response?.statusText ?? 'Unknown error',
            data: response.data,
        };
    }
    else {
        return { status: ApiStatus.Loaded, data: response.data };
    }
};
export const sendCancellationDecision = async (decision) => {
    const endpoint = `HolidayBooking/${decision.approveOrReject}Cancellation`;
    const response = await axios.post(endpoint, { bookingId: decision.bookingId, reason: decision.rejectionReason }, { skipAuth: true });
    return getResponseData(response);
};
export const getHolidayBookFormFiltered = async (filter) => {
    const endpoint = 'holidayBooking/GetHolidayBookFormFiltered';
    const response = await axios.post(endpoint, filter);
    return getResponseData(response);
};
export const getHolidayStatus = async (bookingId) => {
    const endpoint = `holidayBooking/GetHolidayStatus?bookingId=${bookingId}`;
    const response = await axios.get(endpoint, { skipAuth: true });
    return getResponseData(response);
};
export const getHolidayBookings = async () => {
    const endpoint = 'holidayBooking/Get';
    const response = await axios.get(endpoint);
    return getResponseData(response);
};
export const addHolidayBooking = async (bookingForm) => {
    const endpoint = 'holidayBooking/Add';
    await axios.post(endpoint, bookingForm);
    return;
};
export const withdrawHolidayBooking = async (bookingId) => {
    const endpoint = 'holidayBooking/withdraw';
    return await axios.post(endpoint, { bookingId });
};
export const sendApprovalRequestReminder = async (bookingId) => {
    const endpoint = 'holidayBooking/sendApprovalRequestReminder';
    return await axios.post(endpoint, { bookingId });
};
export const sendCancellationApprovalRequestReminder = async (bookingId) => {
    const endpoint = 'holidayBooking/sendCancellationApprovalRequestReminder';
    return await axios.post(endpoint, { bookingId });
};
export const cancelBooking = async (bookingId) => {
    const endpoint = 'holidayBooking/cancel';
    return await axios.post(endpoint, { bookingId });
};
export const getHolidayRequests = async (approvalStatuses) => {
    const endpoint = 'holidayRequests';
    const response = await managerAxios.get(endpoint, {
        params: { approvalStatuses },
    });
    return getResponseData(response);
};
